import { Link } from 'react-router-dom';
import { FadeUp } from './Motion.jsx';
import { IconDocument } from './Icons.jsx';

export default function ResourceList({ title = 'Documents & resources', items }) {
  return (
    <FadeUp>
      <section className="resources" aria-label={title}>
        <h2 className="resources-title">{title}</h2>
        <ul className="resources-list">
          {items.map((r) => {
            const inner = (
              <>
                <span className="resources-icon" aria-hidden="true">
                  {r.Icon ? <r.Icon /> : <IconDocument />}
                </span>
                <span>
                  <span className="resources-item-label">{r.label}</span>
                  {r.meta && <span className="resources-item-meta">{r.meta}</span>}
                </span>
                <span className="resources-arrow" aria-hidden="true">&rarr;</span>
              </>
            );

            return (
              <li key={r.label}>
                {r.to ? (
                  <Link className="resources-item" to={r.to}>{inner}</Link>
                ) : (
                  <a className="resources-item" href={r.href} target="_blank" rel="noopener noreferrer">
                    {inner}
                  </a>
                )}
              </li>
            );
          })}
        </ul>
      </section>
    </FadeUp>
  );
}